export enum FilterFields {
  IsNewHomeNeeded = 'isNewHomeNeeded',
  isAnotherOfferInvolved = 'isAnotherOfferInvolved',
  Severity = 'severity',
  Status = 'status',
  LastDayOnTheProject = 'lastDayOnTheProject',
  ProjectEnd = 'projectEnd',
  UserStatuses = 'userStatuses',
  InvolvedUsers = 'involvedUsers',
  FlagAuthors = 'flagAuthors',
  FlagManagers = 'flagManagers',
  AssignedTomIds = 'assignedTomIds',
  AssignedPrIds = 'assignedPrIds',
  LegalLocations = 'legalLocations',
  AssignedProjects = 'assignedProjects',
  AffectedProjects = 'affectedProjects',
  ReasonsSubReasons = 'reasonsSubReasons',
  ResolvedDateFrom = 'resolvedDateFrom',
  ResolvedDateTo = 'resolvedDateTo',
  EscalationDateFrom = 'escalationDateFrom',
  EscalationDateTo = 'escalationDateTo',
  IsEscalatedByClient = 'isEscalatedByClient',
}
